import { Check, ExternalLink, Plus, ShieldCheck, Syringe } from 'lucide-react';

const STATUS = {
  completed: { label: '已接种', className: 'completed' },
  due: { label: '到参考日', className: 'due' },
  needs_confirmation: { label: '性别待确认', className: 'overdue' },
  future_record: { label: '日期待核对', className: 'overdue' },
  needs_review: { label: '日期待核对', className: 'overdue' },
  overdue: { label: '暂无记录', className: 'upcoming' },
  upcoming: { label: '尚未到月龄', className: 'upcoming' },
};

export default function VaccinePage({ profile, vaccine, onOpenProfile, onOpenDose, onOpenOptional }) {
  const schedule = vaccine.schedule ?? [];
  const records = vaccine.records ?? [];
  const optionalRecords = records.filter((record) => record.category === 'optional');
  const next = schedule.find((item) => item.status !== 'completed');

  return (
    <div className="page page--detail page--vaccine">
      <header className="vaccine-header">
        <div><span className="eyebrow">健康档案</span><h1>疫苗接种</h1><p>{vaccine.version}</p></div>
        <ShieldCheck size={42} strokeWidth={1.5} aria-hidden="true" />
      </header>

      {!profile.birthDate ? (
        <section className="setup-notice">
          <Syringe size={24} />
          <div><strong>设置宝宝生日后生成日程</strong><span>还可选择性别、乙脑和甲肝接种方案。</span></div>
          <button type="button" className="button button--primary" onClick={onOpenProfile}>设置资料</button>
        </section>
      ) : (
        <>
          <section className="vaccine-summary">
            <div><span>已登记</span><strong>{schedule.filter((item) => item.status === 'completed').length}<small> 剂</small></strong></div>
            <div><span>下一项</span><strong className="vaccine-summary__next">{next ? next.name : '国家日程已登记完成'}</strong><small>{next ? `${next.dueDate} · ${next.dose}` : ''}</small>{next ? <button type="button" className="button button--secondary vaccine-summary__action" onClick={() => onOpenDose(next)}>查看下一项</button> : null}</div>
          </section>

          <section className="official-note">
            <strong>状态说明</strong>
            <p>“暂无记录”只表示工作台内没有记录，不等于漏种；参考日期不是预约日期。时间轴日期按月龄或已登记首剂的程序间隔推算，仅供参考，并非预约日期；接种时间、补种与特殊健康情况请以预防接种证和当地接种门诊评估为准。</p>
            <a href={vaccine.sourceUrl} target="_blank" rel="noreferrer">查看官方文件 <ExternalLink size={14} /></a>
          </section>

          <section className="vaccine-section">
            <div className="section-heading"><div><span className="eyebrow">国家免疫规划</span><h2>接种时间轴</h2></div><button type="button" className="text-button" onClick={onOpenProfile}>调整方案</button></div>
            <div className="vaccine-timeline">
              {schedule.map((item) => {
                const status = STATUS[item.status] || { label: '待核对', className: 'overdue' };
                return (
                  <button type="button" className={`vaccine-row vaccine-row--${status.className}`} key={item.id} onClick={() => onOpenDose(item)}>
                    <span className="vaccine-row__marker">{item.status === 'completed' ? <Check size={15} /> : null}</span>
                    <span className="vaccine-row__date">{item.dueDate}<small>参考日 · {item.months < 12 ? `${item.months} 月龄` : `${item.months / 12} 岁`}</small></span>
                    <span className="vaccine-row__main"><strong>{item.name}</strong><small>{item.dose} · {item.short}{item.note ? ` · ${item.note}` : ''}</small></span>
                    <span className={`status-badge status-badge--${status.className}`}>{status.label}</span>
                  </button>
                );
              })}
            </div>
          </section>
        </>
      )}

      <section className="vaccine-section vaccine-section--optional">
        <div className="section-heading"><div><span className="eyebrow">自费 / 其他</span><h2>其他接种记录</h2></div><button type="button" className="text-button" onClick={onOpenOptional}><Plus size={16} />登记</button></div>
        {optionalRecords.length ? (
          <div className="optional-vaccines">
            {optionalRecords.map((record) => (
              <button type="button" key={record.scheduleId} onClick={() => onOpenOptional(record)}>
                <span className="vaccine-row__marker"><Check size={15} /></span>
                <span><strong>{record.vaccineName || '其他疫苗'}</strong><small>{record.administeredAt} · {record.doseLabel || '已接种'}{record.site ? ` · ${record.site}` : ''}</small></span>
              </button>
            ))}
          </div>
        ) : <div className="empty-state"><strong>暂无其他疫苗记录</strong><span>流感、轮状病毒等可在这里单独登记。</span></div>}
      </section>
    </div>
  );
}
